import "./AudioPlayer.css";
import PlayButton, {
  PlayButtonProps,
} from "../ButtonsAndControls/VideoAndAudioOnly/PlayButton";
import VolumeControl, {
  VolumeControlProps,
} from "../ButtonsAndControls/VideoAndAudioOnly/VolumeControl";
import NewWindowButton, {
  NewWindowButtonProps,
} from "../ButtonsAndControls/NewWindowButton";
import PlaybackSpeedControl, {
  PlaybackControlProps,
} from "../ButtonsAndControls/VideoAndAudioOnly/PlaybackSpeedControl";

interface PlayerControlsProps {
  PlayButtonProps: PlayButtonProps;
  VolumeControlProps: VolumeControlProps;
  NewWindowButtonProps: NewWindowButtonProps;
  PlaybackControlProps: PlaybackControlProps;
}

const PlayerControls = ({
  PlayButtonProps,
  VolumeControlProps,
  NewWindowButtonProps,
  PlaybackControlProps,
}: PlayerControlsProps) => {
  const { isPlaying, setIsPlaying, ...playButtonProps } = PlayButtonProps;
  const { muted, setMuted, volume, setVolume, ...volumeControlProps } =
    VolumeControlProps;
  const { playerInteractionId, handleOpenInNewWindow, isLoading } =
    NewWindowButtonProps;
  const { playbackSpeed, setPlaybackSpeed } = PlaybackControlProps;

  return (
    <div className="flex justify-between">
      <div className="flex items-center">
        <PlayButton
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          {...playButtonProps}
        />
        <PlaybackSpeedControl
          playbackSpeed={playbackSpeed}
          setPlaybackSpeed={setPlaybackSpeed}
        />
        <VolumeControl
          muted={muted}
          setMuted={setMuted}
          volume={volume}
          setVolume={setVolume}
          {...volumeControlProps}
        />
      </div>
      <div className="flex items-center">
        <NewWindowButton
          handleOpenInNewWindow={handleOpenInNewWindow}
          playerInteractionId={playerInteractionId}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default PlayerControls;
